import { AdminPermission } from './permissions.model';

export type UsersDataResponse = {
  data: UserDataFirebaseResponse[];
  totalPages: number;
};

export type Role = 'manager' | 'user';
export const rolesArray = ['manager', 'user'] as const;
export const roleLabels: Record<Role, string> = {
  manager: 'Manager',
  user: 'User',
};

export type Permission = 'all' | 'editor' | 'roomServiceManager' | 'rentalManager' | 'reportManager' | 'spaManager' | 'storeManager';
export const permissionsArray = ['all', 'editor', 'roomServiceManager', 'rentalManager', 'reportManager', 'spaManager', 'storeManager'] as const;
export const permissionLabels: Record<Permission, string> = {
  all: 'All Permissions',
  editor: 'Editor',
  roomServiceManager: 'Room Service Manager',
  rentalManager: 'Rental Manager',
  reportManager: 'Report Manager',
  spaManager: 'SPA Manager',
  storeManager: 'Store Manager',
};

export type StaffServicePermission = 'reports' | 'roomservice' | 'store' | 'rental' | 'qrscanner' | 'rooms';
export const staffServicePermissionsArray = ['reports', 'roomservice', 'store', 'rental', 'qrscanner', 'rooms'] as const;
export const staffServicePermissionLabels: Record<StaffServicePermission, string> = {
  reports: 'Reports',
  roomservice: 'Room Service',
  store: 'Store',
  rental: 'Rental',
  qrscanner: 'QR Scanner',
  rooms: 'Rooms',
};

export type Language = 'pl' | 'en' | 'de' | 'fr' | 'es' | 'it' | 'cz' | 'sk' | 'no' | 'se' | 'ru' | 'ua' | 'gr';
export const languagesArray = ['pl', 'en', 'de', 'fr', 'es', 'it', 'cz', 'sk', 'no', 'se', 'ru', 'ua', 'gr'] as const;
export const languageLabels: Record<Language, string> = {
  pl: 'Polski',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
  cz: 'Čeština',
  sk: 'Slovenčina',
  no: 'Norsk',
  se: 'Svenska',
  ru: 'Русский',
  ua: 'Українська',
  gr: 'Ελληνικά',
};

export interface UserDataFirebaseResponse {
  id: string;
  email: string;
  displayName?: string | undefined;
  name?: string;
  surname?: string;
  firstLogin?: boolean;
  isStore?: boolean;
  createdAt?: string;
  associated_organization?: string;
  organizations?: string[];
  photoURL?: string;
  role?: Role[];
  phoneNumber?: string;
  password?: string;
  permissions?: Permission[];
  staffService?: boolean;
  staffServicePermissions?: StaffServicePermission[];
  language?: Language;
  /** Flaga personelu (`users/{uid}.isStaff` + claim). Konta z panelu mają ją zawsze. */
  isStaff?: boolean;
  /** Id organizacji/hoteli, których to konto jest właścicielem (claim `owner`). */
  owner?: string[];
  /** Administrator HotelSpot — claim `isHotelspotAdmin`. */
  isHotelspotAdmin?: boolean;
  /** Zawężenie uprawnień admina (claim `adminPermission`); null = pełny dostęp. */
  adminPermission?: AdminPermission | null;
}

export interface UserDataFirebaseRequest {
  name: string;
  surname: string;
  email: string;
  role: Role[];
  associated_organization?: string;
  organizations?: string[];
  phoneNumber: string;
  password?: string;
  permissions?: Permission[];
  staffService?: boolean;
  staffServicePermissions?: StaffServicePermission[];
  language?: Language;
  /** Konta z tego formularza to zawsze personel — backend i tak wymusza `true`. */
  isStaff?: boolean;
  owner?: string[];
  isHotelspotAdmin?: boolean;
  adminPermission?: AdminPermission | null;
  /**
   * Zgoda superadmina na podniesienie istniejącego konta Auth (gościa) do konta
   * personelu — wysyłana dopiero po potwierdzeniu w modalu.
   */
  promoteExisting?: boolean;
}

export interface UserDataFirebasePatchRequest {
  uid: string;
  data: UserDataFirebaseRequest;
}
